import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const processDesignActivityCount = z
  .object({
    id: z.string().hidden().describe('Unique identifier'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('The activity being counted'),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Error', name: 'Error' },
      { value: 'Complete', name: 'Complete' },
    ])
      .nullable()
      .optional()
      .describe('The token status being counted'),

    tokenCount: z
      .number()
      .nullable()
      .optional()
      .describe('Number of tokens at this activity with this status'),

    designUuid: z
      .string()
      .nullable()
      .optional()
      .describe('The design UUID for this process design'),

    processDesignId: z.uuid().hidden().describe('Foreign key to ProcessDesign'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processDesign: belongsTo('ProcessDesign'),

    tenant: references('Tenant'),
  })
  .describe(
    'Token counts per activity and status for a process design.\n\nReplaces the process-engine-library view to expose the tenant partition\ncolumn and apply the Tenant Scoped mixin.',
  )
  .as('ProcessDesignActivityCount');

export { processDesignActivityCount as processDesignActivityCountSchema };
